import FlagSelect from './FlagSelect'

export default FlagSelect
